export const MovementRequestStatus = {
    PendingSend : "PendingSend",
    PendingValidation : "PendingValidation",
    Processing : "Processing",
    Validated : "Validated",
    ValidatedPartial : "ValidatedPartial",
    Rejected : "Rejected",
    Error : "Error",
    
    InsurerError : "InsurerError",
    InsurerRejected : "InsurerRejected",
    InsurerProcessed : "InsurerProcessed",
} as const;

export type MovementRequestStatus = (typeof MovementRequestStatus)[keyof typeof MovementRequestStatus];

